import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";

/* jshint esnext: true */
import React from 'react';
import { mixClass } from 'class-lib';
import SemanticUI from '../molecules/SemanticUI';

var Description = function Description(props) {
  var children = props.children,
      className = props.className,
      lineAtom = props.lineAtom,
      others = _objectWithoutProperties(props, ["children", "className", "lineAtom"]);

  var classes = mixClass(className, 'description');
  return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, others, {
    ui: false,
    className: classes
  }), children && children.map ? children.map(function (v, k) {
    return /*#__PURE__*/React.createElement(SemanticUI, {
      atom: lineAtom,
      key: k
    }, v);
  }) : children);
};

export default Description;